{
  "title": "Connectors",
  "refresh": "Refresh",
  "save": "Save",
  "cancel": "Cancel",
  "saving": "Saving",
  "error": "Something went wrong",
  "index": "No.",
  "every": "every {{value}}",
  "seconds_one": "{{count}} second",
  "seconds_other": "{{count}} seconds",
  "minutes_one": "{{count}} minute",
  "minutes_other": "{{count}} minutes",
  "status": {
    "ok": "Running",
    "error": "Error",
    "off": "Off"
  },
  "ws": {
    "idle": "Idle",
    "connecting": "Connecting",
    "open": "Connected",
    "reconnecting": "Reconnecting"
  },
  "source": {
    "title": "Live data source",
    "desc": "Where indicator values come from and the source state",
    "name": "Source",
    "mock": "Simulator (test data)",
    "unified": "ATNT unified server",
    "state": "State",
    "lastSuccess": "Last successful poll",
    "interval": "Poll interval",
    "bound": "Bound indicators",
    "boundValue": "{{bound}} / {{total}}",
    "browser": "Browser connection",
    "notConfigured": "LIVE_SOURCE=unified needs UNIFIED_BASE_URL and UNIFIED_API_KEY — values are offline."
  },
  "site": {
    "title": "Unified server site",
    "desc": "The reservoir's site code on the unified server",
    "label": "Site code",
    "placeholder": "E.g. chotqol",
    "empty": "No site code",
    "orgOnly": "Only an organization admin can change the site code",
    "invalid": "Lowercase Latin letters, digits, “-” and “_” only",
    "saved": "Site code saved"
  },
  "channels": {
    "title": "Indicator channels",
    "desc": "Bind a physical indicator to a unified-server channel: pick or type a channel and press Enter.",
    "readOnly": "Changing channels needs the edit right of “Connectors”.",
    "search": "Search by device or indicator",
    "device": "Device",
    "indicator": "Indicator",
    "channel": "Channel",
    "binding": "Binding",
    "value": "Last value",
    "time": "Measured at",
    "status": "Status",
    "none": "Not bound",
    "bound": "Bound",
    "unknown": "Unknown channel",
    "placeholder": "Choose a channel",
    "saved": "Channel saved",
    "empty": "No physical indicators"
  },
  "help": {
    "title": "How does it work?",
    "items": [
      "From the CSV files sent by the reservoir agents the unified server computes 4 indicators per site: LEVEL, VOLUME, INFLOW and DISCHARGE.",
      "To connect a reservoir, enter its site code (e.g. chotqol) and choose a channel for its physical indicators: hydro:LEVEL, hydro:VOLUME, hydro:INFLOW or hydro:DISCHARGE.",
      "The server data changes hourly; the connector polls it every 5 minutes. A value older than 3 hours is shown as “No data”.",
      "Only values with the “ok” status are accepted; otherwise the indicator is offline and no criteria are checked."
    ]
  },
  "statuses": {
    "connected": "Connected",
    "error": "Error",
    "disabled": "Disabled",
    "checking": "Checking"
  },
  "scopes": {
    "organization": "Organization",
    "tenant": "Reservoir"
  },
  "time": {
    "never": "Never",
    "justNow": "Just now",
    "minutes_one": "{{count}} minute ago",
    "minutes_other": "{{count}} minutes ago",
    "hours_one": "{{count}} hour ago",
    "hours_other": "{{count}} hours ago",
    "days_one": "{{count}} day ago",
    "days_other": "{{count}} days ago"
  },
  "types": {
    "atnt_unified": {
      "name": "ATNT Unified Server",
      "desc": "Sensors and hydro indicators of all 6 reservoirs on one server",
      "help": "The unified server provides the last value of every sensor from the CSV files sent by the reservoir agents, plus 4 hydro indicators."
    },
    "rest": {
      "name": "REST API",
      "desc": "Poll the sensor list and values from your own backend over HTTP",
      "help": "The connector polls the sensor catalog and the latest values with HTTP GET at the given interval. The JSONPath fields point to the id, value and time in the response."
    },
    "mqtt": {
      "name": "MQTT broker",
      "desc": "Receive sensor messages from MQTT topics in real time",
      "help": "The connector subscribes to the broker; every topic matching the filter becomes a separate sensor (JSON, CSV or a plain number)."
    },
    "opcua": {
      "name": "OPC UA",
      "desc": "Read OPC UA nodes of SCADA and PLC systems",
      "help": "The connector connects to the OPC UA server and reads the listed nodes (NodeId) at the given interval. Each node is one sensor."
    },
    "modbus_tcp": {
      "name": "Modbus TCP",
      "desc": "Poll controller registers over Modbus TCP",
      "help": "The connector reads the listed registers from a Modbus TCP device (IP, port, unit ID) and applies the scale factor. Each register is one sensor."
    },
    "webhook": {
      "name": "Webhook",
      "desc": "The external system pushes data itself (HTTP POST)",
      "help": "The external system POSTs values to the given URL and signs every request with the secret (X-Signature, HMAC-SHA256). Sensors appear when the first data arrives."
    },
    "file_import": {
      "name": "File import (CSV / Excel)",
      "desc": "Upload logger files manually or on a schedule",
      "help": "Every uploaded file is read with the column map: the time column plus one sensor per data column."
    }
  },
  "list": {
    "title": "Connectors",
    "create": "Add connector",
    "search": "Search by name, type or address",
    "typeFilter": "Filter by type",
    "allTypes": "All types",
    "statusFilter": "Filter by status",
    "allStatuses": "All statuses",
    "name": "Connector",
    "type": "Type",
    "scope": "Scope",
    "status": "Status",
    "sensors": "Sensors",
    "lastSync": "Last sync",
    "empty": "No connectors yet",
    "emptyHint": "Connect the source your sensors and their values come from."
  },
  "table": {
    "actions": "Actions",
    "actionsLabel": "Actions"
  },
  "menu": {
    "open": "Open",
    "test": "Test",
    "enable": "Enable",
    "disable": "Disable",
    "edit": "Edit",
    "delete": "Delete",
    "enabled": "Connector enabled",
    "disabled": "Connector disabled",
    "deleteTitle": "Delete connector",
    "deleteText": "The connector “{{name}}” will be deleted. Bound indicators will stop receiving values.",
    "deleteOrgText": "The organization connector “{{name}}” will be deleted for all reservoirs. Bound indicators will stop receiving values.",
    "deleted": "Connector deleted"
  },
  "test": {
    "run": "Test connection",
    "running": "Testing…",
    "ok": "Connection successful",
    "failed": "Connection failed",
    "latency": "{{ms}} ms",
    "sensors_one": "{{count}} sensor found",
    "sensors_other": "{{count}} sensors found"
  },
  "panel": {
    "back": "Go back",
    "createTitle": "Add connector",
    "editTitle": "Edit connector",
    "stepType": "Source type",
    "stepSettings": "Settings",
    "pickHint": "Choose where the sensors come from.",
    "changeType": "Change type",
    "connected": "Connected",
    "soon": "Coming soon",
    "saved": "Changes saved",
    "created": "Connector added"
  },
  "common": {
    "unsavedTitle": "Unsaved changes",
    "unsavedText": "The entered data will be lost.",
    "stay": "Stay",
    "leave": "Leave"
  },
  "form": {
    "name": "Connector name",
    "namePlaceholder": "e.g. Contractor telemetry API",
    "description": "Description",
    "descriptionPlaceholder": "Short note (optional)",
    "scope": "Scope",
    "scopeHint": "An organization connector is visible in every reservoir of the organization.",
    "scopeOrgOnly": "Only organization admins can add organization connectors.",
    "scopeFixed": "The scope cannot be changed after creation.",
    "connection": "Connection",
    "enabled": "Connector enabled",
    "pollInterval": "Poll interval",
    "pollHint": "From 10 seconds to 24 hours",
    "sec": "sec",
    "secretStored": "Stored: {{hint}} — enter a new one to replace it",
    "secretPlaceholder": "Enter the secret value",
    "show": "Show",
    "hide": "Hide",
    "copy": "Copy",
    "copied": "Copied",
    "copyFailed": "Could not copy",
    "regenerate": "Generate a new secret",
    "baseUrl": "Server URL",
    "baseUrlHint": "With the /api prefix, e.g. https://monitoring.uzgidro.uz/api",
    "apiKey": "API key (X-API-Key)",
    "apiKeyHint": "Issued in the unified server under “External system keys”; shown only once.",
    "siteCode": "Site code",
    "siteCodeHint": "Per reservoir — changed on the “Unified server site” card.",
    "siteCodeEmpty": "Not set",
    "auth": "Authentication",
    "authKinds": {
      "none": "None",
      "header": "Header key",
      "bearer": "Bearer token"
    },
    "headerName": "Header name",
    "headerValue": "Key value",
    "token": "Token",
    "sensorsPath": "Sensors path",
    "valuesPath": "Values path",
    "idPath": "ID (JSONPath)",
    "valuePath": "Value (JSONPath)",
    "timePath": "Time (JSONPath)",
    "brokerUrl": "Broker URL",
    "brokerHint": "mqtt://, mqtts://, ws:// or wss://",
    "topic": "Topic filter",
    "topicHint": "+ matches one level, # matches all remaining levels",
    "username": "Username",
    "password": "Password",
    "payloadFormat": "Payload format",
    "endpointUrl": "Endpoint URL",
    "securityMode": "Security mode",
    "security": {
      "none": "None",
      "sign": "Sign",
      "sign_encrypt": "Sign & encrypt"
    },
    "nodeIds": "Nodes (NodeId)",
    "nodeIdsHint": "One NodeId per line",
    "host": "Host (IP or name)",
    "port": "Port",
    "unitId": "Unit ID",
    "registers": "Registers",
    "addRegister": "Add register",
    "registerName": "Register name",
    "address": "Address",
    "removeRegister": "Remove register",
    "registerKind": "Register type",
    "registerKinds": {
      "holding": "Holding",
      "input": "Input",
      "coil": "Coil",
      "discrete": "Discrete"
    },
    "dataType": "Data type",
    "scale": "Scale",
    "unit": "Unit",
    "webhookUrl": "Webhook URL",
    "webhookUrlHint": "The external system POSTs values to this URL.",
    "webhookSecret": "Secret",
    "webhookSecretOnce": "Copy the secret now — it is not shown in full after saving.",
    "webhookSecretHint": "The secret is stored. A new one replaces it once saved.",
    "fileFormat": "File format",
    "delimiter": "Delimiter",
    "delimiters": {
      "comma": "Comma ( , )",
      "semicolon": "Semicolon ( ; )",
      "tab": "Tab"
    },
    "timeColumn": "Time column",
    "timeFormat": "Time format",
    "headerRow": "Header row",
    "decimal": "Decimal separator",
    "columns": "Data columns",
    "columnsHint": "One column per line: “Column name | unit”"
  },
  "errors": {
    "required": "Required",
    "url": "Enter a valid URL",
    "interval": "Whole number from 10 to 86400",
    "header": "Latin letters, digits and “-” only",
    "path": "A path starting with “/”",
    "jsonPath": "A JSONPath starting with “$”",
    "host": "IP address or host name",
    "port": "From 1 to 65535",
    "unitId": "From 0 to 255",
    "nodeIds": "Enter at least one NodeId",
    "columns": "Enter at least one column",
    "registers": "At least one register is required",
    "number": "Positive whole number",
    "secret": "Enter the secret value",
    "address": "0–65535",
    "invalid": "Invalid value"
  },
  "detail": {
    "notFound": "Connector not found",
    "notFoundHint": "It was deleted or you have no access to it.",
    "back": "Back to connectors",
    "tabsLabel": "Connector sections",
    "tabs": {
      "overview": "Overview",
      "sensors": "Sensors",
      "channels": "Channels",
      "settings": "Settings",
      "log": "Log"
    }
  },
  "overview": {
    "status": "Status",
    "statusDesc": "Connection to the source and the last sync",
    "state": "State",
    "lastSync": "Last sync",
    "interval": "Poll interval",
    "push": "The source pushes data",
    "bound": "Bound sensors",
    "enabled": "Enabled",
    "yes": "Yes",
    "no": "No",
    "type": "Type",
    "notSet": "Not set",
    "createdAt": "Created",
    "createdBy": "Added by",
    "system": "System",
    "source": "Source",
    "sourceDesc": "Where and how the data is taken",
    "nodes": "Sensors by node",
    "nodesDesc_one": "{{count}} node (device / gateway) · bound / total",
    "nodesDesc_other": "{{count}} nodes (devices / gateways) · bound / total",
    "all": "All",
    "recent": "Recent events",
    "recentDesc": "Syncs, tests and changes"
  },
  "sensors": {
    "hydroNode": "Computed hydro indicators",
    "empty": "No sensors found yet",
    "emptyHint": "Sensors appear here once the first data arrives from the source.",
    "search": "Search by column, node or indicator",
    "filter": "Filter by binding",
    "all": "All",
    "bound": "Bound",
    "unbound": "Unbound",
    "column": "Sensor (column)",
    "channel": "Channel",
    "value": "Last value",
    "time": "Measured",
    "binding": "Bound indicator",
    "notBound": "Not bound",
    "bindPlaceholder": "Choose an indicator",
    "unbind": "Unbind",
    "boundToast": "Sensor bound",
    "unboundToast": "Binding removed",
    "import": "Import as devices",
    "importN_one": "Import as devices ({{count}})",
    "importN_other": "Import as devices ({{count}})",
    "imported_one": "{{devices}} device(s) and {{count}} indicator imported",
    "imported_other": "{{devices}} device(s) and {{count}} indicators imported",
    "importMock": "Test mode: devices are created once the backend is ready",
    "type": "Signal type"
  },
  "log": {
    "time": "Time",
    "level": "Level",
    "message": "Message",
    "search": "Search messages",
    "all": "All",
    "empty": "The log is empty",
    "levels": {
      "info": "Info",
      "warning": "Warning",
      "error": "Error"
    },
    "codes": {
      "sync": {
        "ok": "Sync completed: {{sensors}} sensors, {{ms}} ms"
      },
      "sensors": {
        "stale": "{{count}} sensors have not updated for 3 hours",
        "imported": "Import requested: {{devices}} devices, {{sensors}} sensors (test mode)"
      },
      "source": {
        "timeout": "The source did not answer within {{ms}} ms",
        "retry": "Retrying in {{sec}} s"
      },
      "auth": {
        "failed": "Authorization rejected (HTTP {{status}})"
      },
      "test": {
        "ok": "Connection test passed: {{ms}} ms, {{sensors}} sensors",
        "failed": "Connection test failed: {{error}}"
      },
      "connector": {
        "created": "Connector created",
        "updated": "Settings changed",
        "enabled": "Connector enabled",
        "disabled": "Connector disabled"
      },
      "sensor": {
        "bound": "{{column}} → {{indicator}} bound",
        "unbound": "{{column}} unbound"
      }
    }
  },
  "settings": {
    "title": "Connection settings",
    "desc": "Source address, credentials and poll interval",
    "orgOnly": "This is an organization connector — only organization admins can change it.",
    "readOnly": "Changing connectors requires the edit right of the “Connectors” module."
  }
}
